import * as Styled from './styles';
import { BahamutIcon } from 'icons/colored/Bahamut';
import { EthereumIcon } from 'icons/colored/Ethereum';
import { Blockchain } from 'constants/nfts/blockchains';

export const BlockchainBadge = ({ blockchain }: { blockchain: string }) => {
  return (
    <Styled.NftMediaIconWrapper>
      {blockchain === Blockchain.BAHAMUT ? <BahamutIcon /> : <EthereumIcon />}
    </Styled.NftMediaIconWrapper>
  );
};
